'use client'

import {Text} from '@/components/ui/Typography'
import {Compartment as CompartmentType} from '@/types/box/Compartment'
import Image from 'next/image'
import {useRouter} from '@/i18n/navigation'
import React from 'react'

interface Props {
  compartment: CompartmentType
  index: number
}

export const Compartment: React.FC<Props> = ({compartment, index}) => {
  const router = useRouter()

  const handleClick = (productUrl: string) => {
    router.push(productUrl)
  }

  const product = compartment.product

  if (!product) {
    return null
  }

  return (
    <button
      key={compartment.id}
      className="relative flex flex-col items-center justify-center bg-white p-4 border hover:bg-gray-50 transition-shadow hover:cursor-pointer"
      onClick={() => handleClick(product?.url)}
      title={product?.description}
    >
      {/* Top-left number */}
      <div className="absolute top-2 left-2 text-xl font-semi-bold text-gray-500">{index + 1}</div>

      {/* Centered image */}
      {product.iconUrl && <Image src={product.iconUrl} alt={product.name} title={product.name} height={56} width={56} className="h-16 w-16 mb-2" />}

      {/* Product name */}
      <div className="text-center">
        <Text className="text-gray-700">{product?.name}</Text>
      </div>
    </button>
  )
}
